import { IconName } from "@inflow/icons"
import { isSupportedCountry } from "libphonenumber-js/max"

export const US_LOCALE = "en-US"

export const LANGUAGE_NAMES = {
  aa: "Afaraf",
  ab: "аҧсуа",
  ae: "avesta", // (Avestan)
  af: "Afrikaans",
  ak: "Akan",
  am: "አማርኛ",
  an: "aragonés",
  ar: "العربية",
  as: "অসমীয়া",
  av: "авар",
  ay: "aymar aru",
  az: "azərbaycan dili",
  ba: "башҡортса",
  be: "Беларуская",
  bg: "български",
  bh: "भोजपुरी",
  bi: "Bislama",
  bm: "bamanankan",
  bn: "বাংলা",
  bo: "བོད་སྐད་",
  br: "brezhoneg",
  bs: "bosanski",
  ca: "català",
  ce: "нохчийн мотт",
  ch: "Chamoru",
  co: "corsu",
  cr: "Nehiyaw",
  cs: "čeština",
  cu: "ѩзыкъ словѣньскъ", // (Church Slavonic)
  cv: "чӑваш чӗлхи",
  cy: "Cymraeg",
  da: "dansk",
  de: "Deutsch",
  dv: "ދިވެހި",
  dz: "རྫོང་ཁ",
  ee: "Eʋegbe",
  el: "ελληνικά",
  en: "English",
  eo: "Esperanto",
  es: "español",
  et: "eesti",
  eu: "euskara",
  fa: "فارسی",
  ff: "pulaar", // or Fulfulde variants
  fi: "suomi",
  fj: "vosa Vakaviti",
  fo: "føroyskt",
  fr: "français",
  fy: "Frysk",
  ga: "Gaeilge",
  gd: "Gàidhlig",
  gl: "galego",
  gn: "Avañe'ẽ",
  gu: "ગુજરાતી",
  gv: "Gaelg",
  ha: "Hausa", // Often used in Latin; some communities also use Arabic script
  he: "עברית",
  hi: "हिन्दी",
  ho: "Hiri Motu",
  hr: "hrvatski",
  ht: "Kreyòl ayisyen",
  hu: "magyar",
  hy: "հայերեն",
  hz: "Otjiherero",
  ia: "Interlingua",
  id: "Bahasa Indonesia",
  ie: "Interlingue",
  ig: "Asụsụ Igbo",
  ii: "ꆈꌠ꒿ Nuosuhxop",
  ik: "Iñupiaq",
  io: "Ido",
  is: "íslenska",
  it: "italiano",
  iu: "ᐃᓄᒃᑎᑐᑦ",
  ja: "日本語",
  jv: "basa Jawa",
  ka: "ქართული",
  kg: "kiKongo",
  ki: "Gikuyu",
  kj: "Kuanyama",
  kk: "қазақ тілі",
  kl: "kalaallisut",
  km: "ភាសាខ្មែរ",
  kn: "ಕನ್ನಡ",
  ko: "한국어",
  kr: "Kanuri",
  ks: "کٲشُر", // Kashmiri (in Perso-Arabic script)
  ku: "Kurdî",
  kv: "коми кыв",
  kw: "Kernewek",
  ky: "Кыргызча",
  la: "latina",
  lb: "Lëtzebuergesch",
  lg: "Luganda",
  li: "Limburgs",
  ln: "lingála",
  lo: "ພາສາລາວ",
  lt: "lietuvių",
  lu: "Tshiluba",
  lv: "latviešu",
  mg: "fiteny malagasy",
  mh: "Kajin M̧ajeļ",
  mi: "te reo Māori",
  mk: "македонски",
  ml: "മലയാളം",
  mn: "монгол",
  mr: "मराठी",
  ms: "Bahasa Melayu",
  mt: "Malti",
  my: "ဗမာစာ",
  na: "Ekakairũ Naoero",
  nb: "norsk bokmål",
  nd: "isiNdebele",
  ne: "नेपाली",
  ng: "Ndonga",
  nl: "Nederlands",
  nn: "nynorsk",
  no: "norsk",
  nr: "isiNdebele",
  nv: "Diné bizaad",
  ny: "chiCheŵa",
  oc: "lenga d'òc",
  oj: "ᐊᓂᔑᓈᐯᒧᐎᓐ",
  om: "Afaan Oromoo",
  or: "ଓଡ଼ିଆ",
  os: "ирон æвзаг",
  pa: "ਪੰਜਾਬੀ",
  pi: "पाळि",
  pl: "polski",
  ps: "پښتو",
  pt: "português",
  qu: "Runa Simi",
  rm: "rumantsch",
  rn: "Ikirundi",
  ro: "română",
  ru: "русский",
  rw: "Kinyarwanda",
  sa: "संस्कृतम्",
  sc: "sardu",
  sd: "سنڌي",
  se: "Davvisámegiella",
  sg: "yângâ tî sängö",
  si: "සිංහල",
  sk: "slovenčina",
  sl: "slovenščina",
  sm: "gagana fa'a Samoa",
  sn: "chiShona",
  so: "Soomaaliga",
  sq: "shqip",
  sr: "српски",
  ss: "SiSwati",
  st: "Sesotho",
  su: "Basa Sunda",
  sv: "svenska",
  sw: "Kiswahili",
  ta: "தமிழ்",
  te: "తెలుగు",
  tg: "тоҷикӣ",
  th: "ไทย",
  ti: "ትግርኛ",
  tk: "Türkmençe",
  tl: "Tagalog",
  tn: "Setswana",
  to: "faka Tonga",
  tr: "Türkçe",
  ts: "Xitsonga",
  tt: "татарча",
  tw: "Twi",
  ty: "Reo Tahiti",
  ug: "ئۇيغۇرچە",
  uk: "українська",
  ur: "اردو",
  uz: "oʻzbek",
  ve: "Tshivenḓa",
  vi: "Tiếng Việt",
  vo: "Volapük",
  wa: "walon",
  wo: "Wolof",
  xh: "isiXhosa",
  yi: "ייִדיש",
  yo: "Èdè Yorùbá",
  za: "Saɯ-cəŋƅ", // approximate local name for Zhuang
  zh: "中文",
  zu: "isiZulu",
} as const

function defineSupportedLanguages<
  T extends readonly (keyof typeof LANGUAGE_NAMES)[],
>(langs: T): T {
  return langs
}

export const SUPPORTED_LANGUAGES = defineSupportedLanguages([
  "en",
  "es",
] as const)

export interface CountryData {
  name: string
  dialCode: string
  iconName: IconName
}

const COUNTRIES_DATA = {
  AX: {
    name: "Åland Islands",
    dialCode: "+358",
    iconName: "flagAX",
  },
  AF: { name: "Afghanistan", dialCode: "+93", iconName: "flagAF" },
  AL: { name: "Albania", dialCode: "+355", iconName: "flagAL" },
  DZ: { name: "Algeria", dialCode: "+213", iconName: "flagDZ" },
  AD: { name: "Andorra", dialCode: "+376", iconName: "flagAD" },
  AO: { name: "Angola", dialCode: "+244", iconName: "flagAO" },
  AG: {
    name: "Antigua and Barbuda",
    dialCode: "+1",
    iconName: "flagAG",
  },
  AR: { name: "Argentina", dialCode: "+54", iconName: "flagAR" },
  AM: { name: "Armenia", dialCode: "+374", iconName: "flagAM" },
  AU: { name: "Australia", dialCode: "+61", iconName: "flagAU" },
  AT: { name: "Austria", dialCode: "+43", iconName: "flagAT" },
  AZ: { name: "Azerbaijan", dialCode: "+994", iconName: "flagAZ" },
  BS: { name: "Bahamas", dialCode: "+1", iconName: "flagBS" },
  BH: { name: "Bahrain", dialCode: "+973", iconName: "flagBH" },
  BD: { name: "Bangladesh", dialCode: "+880", iconName: "flagBD" },
  BB: { name: "Barbados", dialCode: "+1", iconName: "flagBB" },
  BY: { name: "Belarus", dialCode: "+375", iconName: "flagBY" },
  BE: { name: "Belgium", dialCode: "+32", iconName: "flagBE" },
  BZ: { name: "Belize", dialCode: "+501", iconName: "flagBZ" },
  BJ: { name: "Benin", dialCode: "+229", iconName: "flagBJ" },
  BT: { name: "Bhutan", dialCode: "+975", iconName: "flagBT" },
  BO: { name: "Bolivia", dialCode: "+591", iconName: "flagBO" },
  BA: {
    name: "Bosnia and Herzegovina",
    dialCode: "+387",
    iconName: "flagBA",
  },
  BW: { name: "Botswana", dialCode: "+267", iconName: "flagBW" },
  BR: { name: "Brazil", dialCode: "+55", iconName: "flagBR" },
  VG: {
    name: "British Virgin Islands",
    dialCode: "+1",
    iconName: "flagVG",
  },
  BN: { name: "Brunei", dialCode: "+673", iconName: "flagBN" },
  BG: { name: "Bulgaria", dialCode: "+359", iconName: "flagBG" },
  BF: { name: "Burkina Faso", dialCode: "+226", iconName: "flagBF" },
  BI: { name: "Burundi", dialCode: "+257", iconName: "flagBI" },
  KH: { name: "Cambodia", dialCode: "+855", iconName: "flagKH" },
  CM: { name: "Cameroon", dialCode: "+237", iconName: "flagCM" },
  CA: { name: "Canada", dialCode: "+1", iconName: "flagCA" },
  CV: { name: "Cape Verde", dialCode: "+238", iconName: "flagCV" },
  KY: { name: "Cayman Islands", dialCode: "+1", iconName: "flagKY" },
  CF: {
    name: "Central African Republic",
    dialCode: "+236",
    iconName: "flagCF",
  },
  TD: { name: "Chad", dialCode: "+235", iconName: "flagTD" },
  CL: { name: "Chile", dialCode: "+56", iconName: "flagCL" },
  CN: { name: "China", dialCode: "+86", iconName: "flagCN" },
  CO: { name: "Colombia", dialCode: "+57", iconName: "flagCO" },
  KM: { name: "Comoros", dialCode: "+269", iconName: "flagKM" },
  CR: { name: "Costa Rica", dialCode: "+506", iconName: "flagCR" },
  HR: { name: "Croatia", dialCode: "+385", iconName: "flagHR" },
  CU: { name: "Cuba", dialCode: "+53", iconName: "flagCU" },
  CY: { name: "Cyprus", dialCode: "+357", iconName: "flagCY" },
  CZ: { name: "Czech Republic", dialCode: "+420", iconName: "flagCZ" },
  CD: {
    name: "Democratic Republic of the Congo",
    dialCode: "+243",
    iconName: "flagCD",
  },
  DK: { name: "Denmark", dialCode: "+45", iconName: "flagDK" },
  DJ: { name: "Djibouti", dialCode: "+253", iconName: "flagDJ" },
  DM: { name: "Dominica", dialCode: "+1", iconName: "flagDM" },
  DO: {
    name: "Dominican Republic",
    dialCode: "+1",
    iconName: "flagDO",
  },
  TL: { name: "East Timor", dialCode: "+670", iconName: "flagTL" },
  EC: { name: "Ecuador", dialCode: "+593", iconName: "flagEC" },
  EG: { name: "Egypt", dialCode: "+20", iconName: "flagEG" },
  SV: { name: "El Salvador", dialCode: "+503", iconName: "flagSV" },
  GQ: {
    name: "Equatorial Guinea",
    dialCode: "+240",
    iconName: "flagGQ",
  },
  ER: { name: "Eritrea", dialCode: "+291", iconName: "flagER" },
  EE: { name: "Estonia", dialCode: "+372", iconName: "flagEE" },
  ET: { name: "Ethiopia", dialCode: "+251", iconName: "flagET" },
  FK: {
    name: "Falkland Islands",
    dialCode: "+500",
    iconName: "flagFK",
  },
  FO: { name: "Faroe Islands", dialCode: "+298", iconName: "flagFO" },
  FJ: { name: "Fiji", dialCode: "+679", iconName: "flagFJ" },
  FI: { name: "Finland", dialCode: "+358", iconName: "flagFI" },
  FR: { name: "France", dialCode: "+33", iconName: "flagFR" },
  GF: { name: "French Guiana", dialCode: "+594", iconName: "flagGF" },
  GA: { name: "Gabon", dialCode: "+241", iconName: "flagGA" },
  GM: { name: "Gambia", dialCode: "+220", iconName: "flagGM" },
  GE: { name: "Georgia", dialCode: "+995", iconName: "flagGE" },
  DE: { name: "Germany", dialCode: "+49", iconName: "flagDE" },
  GH: { name: "Ghana", dialCode: "+233", iconName: "flagGH" },
  GI: { name: "Gibraltar", dialCode: "+350", iconName: "flagGI" },
  GR: { name: "Greece", dialCode: "+30", iconName: "flagGR" },
  GD: { name: "Grenada", dialCode: "+1", iconName: "flagGD" },
  GP: { name: "Guadeloupe", dialCode: "+590", iconName: "flagGP" },
  GT: { name: "Guatemala", dialCode: "+502", iconName: "flagGT" },
  GG: { name: "Guernsey", dialCode: "+44", iconName: "flagGG" },
  GN: { name: "Guinea", dialCode: "+224", iconName: "flagGN" },
  GY: { name: "Guyana", dialCode: "+592", iconName: "flagGY" },
  HT: { name: "Haiti", dialCode: "+509", iconName: "flagHT" },
  HN: { name: "Honduras", dialCode: "+504", iconName: "flagHN" },
  HK: { name: "Hong Kong", dialCode: "+852", iconName: "flagHK" },
  HU: { name: "Hungary", dialCode: "+36", iconName: "flagHU" },
  IS: { name: "Iceland", dialCode: "+354", iconName: "flagIS" },
  IN: { name: "India", dialCode: "+91", iconName: "flagIN" },
  ID: { name: "Indonesia", dialCode: "+62", iconName: "flagID" },
  IR: { name: "Iran", dialCode: "+98", iconName: "flagIR" },
  IQ: { name: "Iraq", dialCode: "+964", iconName: "flagIQ" },
  IE: { name: "Ireland", dialCode: "+353", iconName: "flagIE" },
  IM: { name: "Isle of Man", dialCode: "+44", iconName: "flagIM" },
  IL: { name: "Israel", dialCode: "+972", iconName: "flagIL" },
  IT: { name: "Italy", dialCode: "+39", iconName: "flagIT" },
  CI: { name: "Ivory Coast", dialCode: "+225", iconName: "flagCI" },
  JM: { name: "Jamaica", dialCode: "+1", iconName: "flagJM" },
  JP: { name: "Japan", dialCode: "+81", iconName: "flagJP" },
  JE: { name: "Jersey", dialCode: "+44", iconName: "flagJE" },
  JO: { name: "Jordan", dialCode: "+962", iconName: "flagJO" },
  KZ: { name: "Kazakhstan", dialCode: "+7", iconName: "flagKZ" },
  KE: { name: "Kenya", dialCode: "+254", iconName: "flagKE" },
  KI: { name: "Kiribati", dialCode: "+686", iconName: "flagKI" },
  XK: { name: "Kosovo", dialCode: "+383", iconName: "flagXK" },
  KW: { name: "Kuwait", dialCode: "+965", iconName: "flagKW" },
  KG: { name: "Kyrgyzstan", dialCode: "+996", iconName: "flagKG" },
  LA: { name: "Laos", dialCode: "+856", iconName: "flagLA" },
  LV: { name: "Latvia", dialCode: "+371", iconName: "flagLV" },
  LB: { name: "Lebanon", dialCode: "+961", iconName: "flagLB" },
  LS: { name: "Lesotho", dialCode: "+266", iconName: "flagLS" },
  LR: { name: "Liberia", dialCode: "+231", iconName: "flagLR" },
  LY: { name: "Libya", dialCode: "+218", iconName: "flagLY" },
  LI: {
    name: "Liechtenstein",
    dialCode: "+423",
    iconName: "flagLI",
  },
  LT: { name: "Lithuania", dialCode: "+370", iconName: "flagLT" },
  LU: { name: "Luxembourg", dialCode: "+352", iconName: "flagLU" },
  MG: { name: "Madagascar", dialCode: "+261", iconName: "flagMG" },
  MW: { name: "Malawi", dialCode: "+265", iconName: "flagMW" },
  MY: { name: "Malaysia", dialCode: "+60", iconName: "flagMY" },
  MV: { name: "Maldives", dialCode: "+960", iconName: "flagMV" },
  ML: { name: "Mali", dialCode: "+223", iconName: "flagML" },
  MT: { name: "Malta", dialCode: "+356", iconName: "flagMT" },
  MH: {
    name: "Marshall Islands",
    dialCode: "+692",
    iconName: "flagMH",
  },
  MR: { name: "Mauritania", dialCode: "+222", iconName: "flagMR" },
  MU: { name: "Mauritius", dialCode: "+230", iconName: "flagMU" },
  MX: { name: "Mexico", dialCode: "+52", iconName: "flagMX" },
  FM: { name: "Micronesia", dialCode: "+691", iconName: "flagFM" },
  MD: { name: "Moldova", dialCode: "+373", iconName: "flagMD" },
  MC: { name: "Monaco", dialCode: "+377", iconName: "flagMC" },
  MN: { name: "Mongolia", dialCode: "+976", iconName: "flagMN" },
  ME: { name: "Montenegro", dialCode: "+382", iconName: "flagME" },
  MA: { name: "Morocco", dialCode: "+212", iconName: "flagMA" },
  MZ: { name: "Mozambique", dialCode: "+258", iconName: "flagMZ" },
  MM: { name: "Myanmar", dialCode: "+95", iconName: "flagMM" },
  NA: { name: "Namibia", dialCode: "+264", iconName: "flagNA" },
  NR: { name: "Nauru", dialCode: "+674", iconName: "flagNR" },
  NP: { name: "Nepal", dialCode: "+977", iconName: "flagNP" },
  NL: { name: "Netherlands", dialCode: "+31", iconName: "flagNL" },
  NZ: { name: "New Zealand", dialCode: "+64", iconName: "flagNZ" },
  NI: { name: "Nicaragua", dialCode: "+505", iconName: "flagNI" },
  NE: { name: "Niger", dialCode: "+227", iconName: "flagNE" },
  NG: { name: "Nigeria", dialCode: "+234", iconName: "flagNG" },
  KP: { name: "North Korea", dialCode: "+850", iconName: "flagKP" },
  MK: {
    name: "North Macedonia",
    dialCode: "+389",
    iconName: "flagMK",
  },
  NO: { name: "Norway", dialCode: "+47", iconName: "flagNO" },
  OM: { name: "Oman", dialCode: "+968", iconName: "flagOM" },
  PK: { name: "Pakistan", dialCode: "+92", iconName: "flagPK" },
  PW: { name: "Palau", dialCode: "+680", iconName: "flagPW" },
  PS: { name: "Palestine", dialCode: "+970", iconName: "flagPS" },
  PA: { name: "Panama", dialCode: "+507", iconName: "flagPA" },
  PG: {
    name: "Papua New Guinea",
    dialCode: "+675",
    iconName: "flagPG",
  },
  PY: { name: "Paraguay", dialCode: "+595", iconName: "flagPY" },
  PE: { name: "Peru", dialCode: "+51", iconName: "flagPE" },
  PH: { name: "Philippines", dialCode: "+63", iconName: "flagPH" },
  PL: { name: "Poland", dialCode: "+48", iconName: "flagPL" },
  PT: { name: "Portugal", dialCode: "+351", iconName: "flagPT" },
  PR: { name: "Puerto Rico", dialCode: "+1", iconName: "flagPR" },
  QA: { name: "Qatar", dialCode: "+974", iconName: "flagQA" },
  CG: {
    name: "Republic of the Congo",
    dialCode: "+242",
    iconName: "flagCG",
  },
  RO: { name: "Romania", dialCode: "+40", iconName: "flagRO" },
  RU: { name: "Russia", dialCode: "+7", iconName: "flagRU" },
  RW: { name: "Rwanda", dialCode: "+250", iconName: "flagRW" },
  KN: {
    name: "Saint Kitts and Nevis",
    dialCode: "+1",
    iconName: "flagKN",
  },
  LC: { name: "Saint Lucia", dialCode: "+1", iconName: "flagLC" },
  VC: {
    name: "Saint Vincent and the Grenadines",
    dialCode: "+1",
    iconName: "flagVC",
  },
  WS: { name: "Samoa", dialCode: "+685", iconName: "flagWS" },
  SM: { name: "San Marino", dialCode: "+378", iconName: "flagSM" },
  ST: {
    name: "Sao Tome and Principe",
    dialCode: "+239",
    iconName: "flagST",
  },
  SA: { name: "Saudi Arabia", dialCode: "+966", iconName: "flagSA" },
  SN: { name: "Senegal", dialCode: "+221", iconName: "flagSN" },
  RS: { name: "Serbia", dialCode: "+381", iconName: "flagRS" },
  SC: { name: "Seychelles", dialCode: "+248", iconName: "flagSC" },
  SL: { name: "Sierra Leone", dialCode: "+232", iconName: "flagSL" },
  SG: { name: "Singapore", dialCode: "+65", iconName: "flagSG" },
  SK: { name: "Slovakia", dialCode: "+421", iconName: "flagSK" },
  SI: { name: "Slovenia", dialCode: "+386", iconName: "flagSI" },
  SB: {
    name: "Solomon Islands",
    dialCode: "+677",
    iconName: "flagSB",
  },
  SO: { name: "Somalia", dialCode: "+252", iconName: "flagSO" },
  ZA: { name: "South Africa", dialCode: "+27", iconName: "flagZA" },
  GS: {
    name: "South Georgia and the South Sandwich Islands",
    dialCode: "+500",
    iconName: "flagGS",
  },
  KR: { name: "South Korea", dialCode: "+82", iconName: "flagKR" },
  SS: { name: "South Sudan", dialCode: "+211", iconName: "flagSS" },
  ES: { name: "Spain", dialCode: "+34", iconName: "flagES" },
  LK: { name: "Sri Lanka", dialCode: "+94", iconName: "flagLK" },
  SD: { name: "Sudan", dialCode: "+249", iconName: "flagSD" },
  SR: { name: "Suriname", dialCode: "+597", iconName: "flagSR" },
  SE: { name: "Sweden", dialCode: "+46", iconName: "flagSE" },
  CH: { name: "Switzerland", dialCode: "+41", iconName: "flagCH" },
  SY: { name: "Syria", dialCode: "+963", iconName: "flagSY" },
  TW: { name: "Taiwan", dialCode: "+886", iconName: "flagTW" },
  TJ: { name: "Tajikistan", dialCode: "+992", iconName: "flagTJ" },
  TZ: { name: "Tanzania", dialCode: "+255", iconName: "flagTZ" },
  TH: { name: "Thailand", dialCode: "+66", iconName: "flagTH" },
  TG: { name: "Togo", dialCode: "+228", iconName: "flagTG" },
  TO: { name: "Tonga", dialCode: "+676", iconName: "flagTO" },
  TT: {
    name: "Trinidad and Tobago",
    dialCode: "+1",
    iconName: "flagTT",
  },
  TN: { name: "Tunisia", dialCode: "+216", iconName: "flagTN" },
  TR: { name: "Turkey", dialCode: "+90", iconName: "flagTR" },
  TM: { name: "Turkmenistan", dialCode: "+993", iconName: "flagTM" },
  UG: { name: "Uganda", dialCode: "+256", iconName: "flagUG" },
  UA: { name: "Ukraine", dialCode: "+380", iconName: "flagUA" },
  AE: {
    name: "United Arab Emirates",
    dialCode: "+971",
    iconName: "flagAE",
  },
  GB: {
    name: "United Kingdom",
    dialCode: "+44",
    iconName: "flagGB",
  },
  US: { name: "United States", dialCode: "+1", iconName: "flagUS" },
  UY: { name: "Uruguay", dialCode: "+598", iconName: "flagUY" },
  UZ: { name: "Uzbekistan", dialCode: "+998", iconName: "flagUZ" },
  VE: { name: "Venezuela", dialCode: "+58", iconName: "flagVE" },
  VN: { name: "Vietnam", dialCode: "+84", iconName: "flagVN" },
  YE: { name: "Yemen", dialCode: "+967", iconName: "flagYE" },
  ZM: { name: "Zambia", dialCode: "+260", iconName: "flagZM" },
  ZW: { name: "Zimbabwe", dialCode: "+263", iconName: "flagZW" },
} as const satisfies Record<string, CountryData>

export type CountryIdentifiers = keyof typeof COUNTRIES_DATA

export const COUNTRIES: ReadonlyMap<CountryIdentifiers, CountryData> = new Map(
  Object.entries(COUNTRIES_DATA) as ReadonlyArray<
    readonly [CountryIdentifiers, CountryData]
  >
)

export interface CountryPhoneData {
  code: CountryIdentifiers
  name: string
  dialCode: string
  iconName?: IconName
}

export function getCountriesWithPhoneData(): CountryPhoneData[] {
  const countries: CountryPhoneData[] = []

  for (const [code, data] of COUNTRIES.entries()) {
    if (!isSupportedCountry(code)) continue

    countries.push({
      code,
      name: data.name,
      dialCode: data.dialCode,
      iconName: data.iconName,
    })
  }

  return countries.sort((a, b) => a.name.localeCompare(b.name))
}

function isCountryIdentifier(code: string): code is CountryIdentifiers {
  return code in COUNTRIES_DATA
}

// Accepts any string (e.g. an ISO code from libphonenumber); the type guard
// narrows it to a known identifier before the lookup.
export function getCountryPhoneData(
  code: string
): CountryPhoneData | undefined {
  if (!isCountryIdentifier(code)) return undefined

  const data = COUNTRIES.get(code)
  if (data) {
    return {
      code,
      name: data.name,
      dialCode: data.dialCode,
      iconName: data.iconName,
    }
  }
  return undefined
}

export function searchCountriesForPhone(query: string): CountryPhoneData[] {
  const lowerQuery = query.toLowerCase()
  return getCountriesWithPhoneData().filter(
    (country) =>
      country.name.toLowerCase().includes(lowerQuery) ||
      country.code.toLowerCase().includes(lowerQuery) ||
      country.dialCode.includes(query)
  )
}

type LanguageIdentifier = (typeof SUPPORTED_LANGUAGES)[number] | (string & {})

export function iconForLanguage(
  languageIdentifier?: LanguageIdentifier
): IconName {
  switch (languageIdentifier) {
    case "en":
      return COUNTRIES.get("US")!.iconName
    case "es":
      return COUNTRIES.get("MX")!.iconName
    default:
      return "language"
  }
}

export function getLanguageName(languageIdentifier?: LanguageIdentifier) {
  if (languageIdentifier && languageIdentifier in LANGUAGE_NAMES) {
    return LANGUAGE_NAMES[languageIdentifier as keyof typeof LANGUAGE_NAMES]
  }
  return "English"
}

export function getCountryCodesFromPhoneNumber(
  phoneNumber: string
): CountryIdentifiers[] {
  // Normalize the phone number - remove spaces, dashes, parentheses
  const normalized = phoneNumber.replace(/[\s\-()]/g, "")

  // Ensure it starts with + for consistent matching
  const withPlus = normalized.startsWith("+") ? normalized : `+${normalized}`

  const countryMatches: CountryIdentifiers[] = []
  COUNTRIES.forEach((countryData, countryCode) => {
    if (withPlus.startsWith(countryData.dialCode)) {
      countryMatches.push(countryCode)
    }
  })

  return countryMatches
}
